import pgaLogo from "@/assets/images/pga-logo.svg";
import pgaLogoReversed from "@/assets/images/pga-logo-reversed.svg";
import pgaLogoDecember from "@/assets/images/pga-logo-december.png";
import pgaLogoAprilFools from "@/assets/images/pga-logo-april-fools.gif";
import type { ColorScheme } from "./storage";

export type PgaBrandLogoVariant = "standard" | "december" | "april-fools";

export function getPgaBrandLogo(
  colorScheme: ColorScheme,
  now = new Date()
): { src: string; variant: PgaBrandLogoVariant } {
  if (now.getMonth() === 3 && now.getDate() === 1) {
    return { src: pgaLogoAprilFools, variant: "april-fools" };
  }

  if (now.getMonth() === 11) {
    return { src: pgaLogoDecember, variant: "december" };
  }

  return {
    src: colorScheme === "dark" ? pgaLogoReversed : pgaLogo,
    variant: "standard"
  };
}
